import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import logOut from "../../assets/images/icons/logout.svg";
import { BASE_URL } from '../../env';

const AutoLogout = ({ logout }) => {
    const timeoutRef = useRef(null);
    const logoutDelay = 60 * 60 * 1000; // 60 minutes
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);

    const triggerLogoutModal = () => {
        setShowLogoutPopup(true);
        // Iterate through all keys in localStorage
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);

            // Check if the key contains the BASE_URL
            if (key && key.includes(BASE_URL)) {
                localStorage.removeItem(key);
            }
        }
        // Remove token specifically, if not covered by BASE_URL
        localStorage.removeItem("token");
        localStorage.removeItem("profileUserDetails");
        localStorage.removeItem("staffRoles");
        localStorage.removeItem("reduxState");
        localStorage.removeItem("userId");
        localStorage.removeItem("userLoggedInDetails");
        localStorage.removeItem("completeLoginDetail");
        localStorage.removeItem("loginDateTime");
        localStorage.removeItem("staffLevel");
        localStorage.removeItem("staffPermissionName");
        localStorage.removeItem("RotaTemplateSchedule");
        localStorage.clear();
    };

    const handleCloseModal = () => {
        logout();
        setTimeout(() => {
            setShowLogoutPopup(false);
        }, 2000);
    };

    const resetTimer = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(triggerLogoutModal, logoutDelay);
    };

    useEffect(() => {
        const events = ['mousemove', 'keydown', 'scroll', 'click'];

        events.forEach(event =>
            window.addEventListener(event, resetTimer)
        );

        resetTimer(); // Start the timer initially

        return () => {
            events.forEach(event =>
                window.removeEventListener(event, resetTimer)
            );
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);

    return (
        <>
            <Modal
                show={showLogoutPopup}
                onHide={handleCloseModal}
                className="ftcModalPopup confirmationPopup deletionConfirmation"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Session Expired</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="editBlockContent text-center">
                        <img src={logOut} alt="logout" className="lgoutButton" />
                        <p>Your session has expired. Please log in again to continue.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-sm" variant="danger" onClick={handleCloseModal}>
                        Login
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AutoLogout;
